import { defineComponent as _defineComponent } from 'vue'
import AvailableCourseWorksComponent from "@/components/courseworks/available-courseworks-component.vue";
import BreadCrumbComponent from "@/components/bread-crumb-component.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'courseworks',
  setup(__props) {


return { __sfc: true,AvailableCourseWorksComponent, BreadCrumbComponent }
}

})